module.exports = coreApis.settings;